import {cookie} from '@/app/js/helpers/cookie'

const COOKIE_SELECTOR = '.js-cookie-agreement'
const BUTTON_SELECTOR = '.js-cookie-agreement-button'
const COOKIES_ACCEPT = 'cookiesAccept'
const DAYS = 365
const cookieElement = document.querySelector(COOKIE_SELECTOR)
const OPTIONS = {
  'expires': new Date(new Date().getTime() + (DAYS * 24 * 60 * 60 * 1000)),
  'path:': '/'
}

function hideCookieAgreement() {
  cookieElement.classList.add('hidden')
}

function showCookieAgreement() {
  cookieElement.classList.remove('hidden')
}

export function initCookieAgreement() {
  if (!cookieElement) return
  if (cookie.getCookie(COOKIES_ACCEPT) !== 'true') {
    showCookieAgreement()
  }
  const button = cookieElement.querySelector(BUTTON_SELECTOR)
  button?.addEventListener('click', () => {
    cookie.setCookie(COOKIES_ACCEPT, 'true', OPTIONS)
    hideCookieAgreement()
  })
}
